import { render, staticRenderFns } from "./entidad-form.vue?vue&type=template&id=6906d319&scoped=true&"
import script from "./entidad-form.vue?vue&type=script&lang=js&"
export * from "./entidad-form.vue?vue&type=script&lang=js&"
import style0 from "./entidad-form.vue?vue&type=style&index=0&id=6906d319&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6906d319",
  null
  
)

export default component.exports